import React, { useRef } from 'react';
import { Input } from 'antd';
import './CustomSearchInput.css';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const { Search } = Input;

const CustomSearchInput = ({
	onSearch,
	width = '300px',
	mobileWidth = '160px',
	isFullWidth = false,
	clearTrigger,
}) => {
	const { t } = useTranslation();
	const [searchValue, setSearchValue] = useState('');
	const searchInputRef = useRef(null);

	React.useEffect(() => {
		if (clearTrigger) {
			setSearchValue('');
		}
	}, [clearTrigger]);

	const handleSearch = (value) => {
		onSearch(value);

		const isMobileDevice = /navigator.userAgent/.test(
			/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
		);

		if (isMobileDevice && searchInputRef.current) {
			searchInputRef.current.blur();
		}
	};

	const handleChange = (e) => {
		const value = e.target.value;
		setSearchValue(value);
		
		// Auto-load all products when search is cleared
		if (value === '') {
			onSearch('');
		}
	};

	return (
		<Search
			className='custom-search-input'
			style={{
				'--width': width,
				'--mobile-width': mobileWidth,
				...(isFullWidth && { display: 'block', width: '100%' }),
			}}
			placeholder={`${t('Search here')}...`}
			value={searchValue}
			onChange={handleChange}
			onSearch={handleSearch}
			enterButton
			ref={searchInputRef}
		/>
	);
};

export default CustomSearchInput;
